import * as React from 'react';
import { Header2 } from '@cian/ui-kit/typography';
import { Responsive } from '@cian/ui-kit/responsive';
import { Button } from '@cian/ui-kit/button';
import { ArrowDown16, ArrowUp16 } from '@cian/ui-kit/icons';
import * as classNames from 'classnames';

import * as styles from './Document.css';
import { ILegalDocument } from '../../types/document';
import { ILegalDocumentLink } from '../../types/link';
import { Links } from '../Links';
import { useVisibleOnScroll } from '../../utils/hooks/useVisibleOnScroll';
import { useHiddenBellowOffset } from '../../utils/hooks/useHiddenBellowOffset';

interface IDocumentProps {
  document: ILegalDocument;
  links: ILegalDocumentLink[];
}

export const Document: React.FC<IDocumentProps> = ({ document, links }) => {
  const [open, setOpen] = React.useState(false);

  const scrollToTop = () => {
    window.scrollTo(0, 0);
  };

  const isVisibleOnScrollToTop = useVisibleOnScroll(30);
  const isVisibleUnderOffset = useHiddenBellowOffset(100, false);

  return (
    <article className={styles['page']}>
      <Responsive desktop>
        <aside className={styles['aside']}>
          <Links links={links} activeLink={document.link} />
        </aside>
      </Responsive>
      <main className={styles['main']}>
        <div className={styles['title']}>
          <Header2 as="h1">{document.title}</Header2>

          <Responsive tablet phone>
            <div className={styles['arrow']}>
              <Button
                size="XS"
                theme="fill_white_primary"
                beforeIcon={!open ? <ArrowDown16 color="primary_100" /> : <ArrowUp16 color="primary_100" />}
                onClick={() => setOpen(!open)}
              />
            </div>
          </Responsive>
        </div>
        {open && (
          <Responsive tablet phone>
            <div className={styles['links']}>
              <Links links={links} activeLink={document.link} hideActive />
            </div>
          </Responsive>
        )}
        {/* eslint-disable-next-line react/no-danger */}
        <div className={styles['body']} dangerouslySetInnerHTML={{ __html: document.htmlText }} />
        <div className={styles['sticky-cont']}>
          <div
            className={classNames(styles['sticky-inner'], {
              [styles['sticky-inner-visible']]: isVisibleOnScrollToTop && !isVisibleUnderOffset,
            })}
          >
            <Button size="XS" theme="fill_primary" beforeIcon={<ArrowUp16 color="white_100" />} onClick={scrollToTop}>
              Наверх
            </Button>
          </div>
        </div>
      </main>
    </article>
  );
};
